import { Box, Popover, Typography } from "@mui/material";
import React, { useRef, useState } from "react";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { WorklogMain } from "../../../worklog/worklogMain";

export const WorklogPopover: React.FC<{ employeeId: string; salaryPeriodTypeId: string }> = ({ employeeId, salaryPeriodTypeId }) => {
    const popoverAnchor = useRef(null);
    const [openedPopover, setOpenedPopover] = useState(false);
    const handlePopoverOpen = () => setOpenedPopover(true);
    const handlePopoverClose = () => setOpenedPopover(false);

    return (
        <Box sx={{ width: "15px", display: "inline-block", mr: 0.5 }}>
            <Typography
                ref={popoverAnchor}
                aria-owns={openedPopover ? "mouse-over-popover" : undefined}
                aria-haspopup="true"
                onMouseOver={handlePopoverOpen}
                onMouseLeave={handlePopoverClose}
                onClick={(e) => {e.stopPropagation(); handlePopoverOpen();} }
                sx={{ marginRight: 1 }}
            >
                <CalendarMonthIcon fontSize="small" color="primary" />
            </Typography>
            <Popover
                id="mouse-over-popover"
                open={openedPopover}
                anchorEl={popoverAnchor.current}
                onClose={handlePopoverClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
                onMouseEnter={handlePopoverOpen}
                onMouseLeave={handlePopoverClose}
                slotProps={{
                    paper: {
                        sx: { pointerEvents: "auto !important" }, // paper properly opens and closes on hover
                        onClick: (e) => { e.stopPropagation(); } // prevent click event from propagating to the parent
                    }
                }}
                sx={{ pointerEvents: "none" }}
            >
                <Box sx={{ p: 0 }}>
                    <WorklogMain employeeId={employeeId} salaryPeriodTypeId={salaryPeriodTypeId} />
                </Box>
            </Popover>
        </Box>
    );
};
